import { CircularProgress } from '@mui/material';
import React from 'react';

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 48,
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default Loader;
